import {Injectable} from '@angular/core';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class VoltarAoTopoService {
  private destroy$ = new Subject<void>();
  ativarScrollEvent = new Subject<void>();
  desativarScrollEvent = new Subject<void>();

  ativarEventoScroll() {
    return this.ativarScrollEvent.pipe(takeUntil(this.destroy$));
  }

  desativarEventoScroll() {
    return this.desativarScrollEvent.pipe(takeUntil(this.destroy$));
  }

  desativarEventos() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
